// src/services/cartService.ts
import axios from 'axios';

const API_URL = '/api/cart';

// ========== GERAR OU RECUPERAR SESSION ID ==========
const getSessionId = (): string => {
    let sessionId = localStorage.getItem('graia_session_id');

    if (!sessionId) {
        // Gerar UUID simples
        sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('graia_session_id', sessionId);
    }

    return sessionId;
};

// ========== HEADERS COM TOKEN E SESSION ==========
const getHeaders = () => {
    const token = localStorage.getItem('accessToken');
    const sessionId = getSessionId();

    return {
        'Content-Type': 'application/json',
        'x-session-id': sessionId,
        ...(token && { 'Authorization': `Bearer ${token}` })
    };
};

// ========== API CALLS ==========

export const cartService = {
    // Obter carrinho atual
    async getCart() {
        try {
            const response = await axios.get(API_URL, {
                headers: getHeaders()
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter carrinho:', error);
            return { items: [], itemCount: 0 };
        }
    },

    // Adicionar item ao carrinho
    async addItem(productId: string, planId: string, couponCode?: string) {  // ✅ ADICIONAR couponCode
        try {
            const response = await axios.post(
                `${API_URL}/add`,
                {
                    productId,
                    planId,
                    couponCode: couponCode || null  // ✅ ENVIAR CUPOM
                },
                { headers: getHeaders() }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao adicionar item:', error);
            throw error;
        }
    },

    // Remover item do carrinho
    async removeItem(productId: string, planId: string) {
        try {
            const response = await axios.delete(
                `${API_URL}/remove`,
                {
                    headers: getHeaders(),
                    data: { productId, planId }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao remover item:', error);
            throw error;
        }
    },

    // Limpar carrinho
    async clearCart() {
        try {
            const response = await axios.post(
                `${API_URL}/clear`,
                {},
                { headers: getHeaders() }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao limpar carrinho:', error);
            throw error;
        }
    },

    // Sincronizar carrinho após login
    async syncCart() {
        try {
            const response = await axios.post(
                `${API_URL}/sync`,
                {},
                { headers: getHeaders() }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao sincronizar carrinho:', error);
            throw error;
        }
    }
};